// extracted by mini-css-extract-plugin
module.exports = {"formHeadline":"form-headline-module--form-headline--1T1dC"};